// src/services/permission.service.ts
// import { privateRequest } from "../axios";

export interface Permission {
  id: number;
  name: string;
  actionName?: string;
  method?: "GET" | "POST" | "PUT" | "DELETE" | string; // allow extra methods too
  baseUrl?: string;
  path?: string;
  description?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface PermissionsResponse {
  rows: Permission[];
  count: number;
}

export interface ApiResponse<T> {
  statusCode: number;
  success: boolean;
  message: string;
  data: T;
}
const ENDPOINTS = {
  PERMISSION: "/permission",
  PERMISSION_ID: (id: number | string) => `/permission/${id}`,
};

// ✅ Get Permissions (with optional query params)
// const getPermissions = async (
//   params?: Record<string, any>
// ): Promise<PermissionsResponse> => {
//   const response = await privateRequest.get<ApiResponse<PermissionsResponse>>(
//     ENDPOINTS.PERMISSION,
//     { params }
//   );
//   return response.data.data; // ⬅️ always inside `data`
// };

// // ✅ Get Permission by ID
// const getPermissionById = async (id: number | string): Promise<Permission> => {
//   const response = await privateRequest.get<Permission>(
//     ENDPOINTS.PERMISSION_ID(id)
//   );
//   return response.data.data;
// };

// // ✅ Add Permission
// const addPermission = async (
//   data: Omit<Permission, "id">
// ): Promise<Permission> => {
//   const response = await privateRequest.post<Permission>(
//     ENDPOINTS.PERMISSION,
//     data
//   );
//   return response.data;
// };

// // ✅ Update Permission
// const updatePermission = async (
//   id: number | string,
//   data: Partial<Permission>
// ): Promise<Permission> => {
//   const response = await privateRequest.put<Permission>(
//     ENDPOINTS.PERMISSION_ID(id),
//     data
//   );
//   return response.data;
// };

// // ✅ Delete Permission
// const deletePermission = async (
//   id: number | string
// ): Promise<{ success: boolean; message?: string }> => {
//   const response = await privateRequest.delete<{
//     success: boolean;
//     message?: string;
//   }>(ENDPOINTS.PERMISSION_ID(id));
//   return response.data;
// };

const PermissionService = {
  // getPermissions,
  // getPermissionById,
  // addPermission,
  // updatePermission,
  // deletePermission,
};

export default PermissionService;
